import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <div class={{this.wrapperClassNames}}>
  {{#if this.isNotifyUser}}
    <h3>{{this.formattedName}}</h3>
    <div class="controls">
      <label class="radio checkbox-label">
        <input
          id="radio_{{this.flag.name_key}}"
          {{on "click" (action "changePostActionType" this.flag)}}
          type="radio"
          name="post_action_type_index"
        />

        <div class="flag-action-type-details">
          <span class="description">{{html-safe this.flag.description}}</span>
          {{#if this.showMessageInput}}
            <Textarea
              name="message"
              class="flag-message"
              placeholder={{this.customPlaceholder}}
              aria-label={{i18n "flagging.notify_user_textarea_label"}}
              @value={{this.message}}
            />
            <div
              class={{concat-class
                "custom-message-length"
                this.customMessageLengthClasses
              }}
            >
              {{this.customMessageLength}}
            </div>
          {{/if}}
        </div>
      </label>
    </div>
    {{#if this.staffFlagsAvailable}}
      <hr />
      <h3>{{i18n "flagging.notify_staff"}}</h3>
    {{/if}}
  {{else}}
    <div class="controls {{this.flag.name_key}}">
      <label class="radio checkbox-label">
        <input
          id="radio_{{this.flag.name_key}}"
          {{on "click" (action "changePostActionType" this.flag)}}
          type="radio"
          name="post_action_type_index"
        />
        <div class="flag-action-type-details">
          <strong>{{this.formattedName}}</strong>
          {{#if this.showDescription}}
            <div class="description">{{html-safe this.description}}</div>
          {{/if}}
          {{#if this.showMessageInput}}
            <Textarea
              name="message"
              class="flag-message"
              placeholder={{this.customPlaceholder}}
              aria-label={{i18n "flagging.notify_moderators_textarea_label"}}
              @value={{this.message}}
            />
            <div
              class={{concat-class
                "custom-message-length"
                this.customMessageLengthClasses
              }}
            >
              {{this.customMessageLength}}
            </div>
          {{/if}}
        </div>
      </label>
      {{#if this.showConfirmation}}
        <label class="checkbox-label flag-confirmation">
          <Input
            name="confirmation"
            @type="checkbox"
            @checked={{this.isConfirmed}}
          />
          <span>{{i18n "flagging.confirmation_illegal"}}</span>
        </label>
      {{/if}}
    </div>
  {{/if}}
</div>
*/
{
  "id": "zbW2CiJM",
  "block": "[[[10,0],[15,0,[30,0,[\"wrapperClassNames\"]]],[12],[1,\"\\n\"],[41,[30,0,[\"isNotifyUser\"]],[[[1,\"    \"],[10,\"h3\"],[12],[1,[30,0,[\"formattedName\"]]],[13],[1,\"\\n    \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"radio checkbox-label\"],[12],[1,\"\\n        \"],[11,\"input\"],[16,1,[29,[\"radio_\",[30,0,[\"flag\",\"name_key\"]]]]],[24,3,\"post_action_type_index\"],[24,4,\"radio\"],[4,[38,1],[\"click\",[28,[37,2],[[30,0],\"changePostActionType\",[30,0,[\"flag\"]]],null]],null],[12],[13],[1,\"\\n\\n        \"],[10,0],[14,0,\"flag-action-type-details\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"description\"],[12],[1,[28,[35,3],[[30,0,[\"flag\",\"description\"]]],null]],[13],[1,\"\\n\"],[41,[30,0,[\"showMessageInput\"]],[[[1,\"            \"],[8,[39,4],[[24,3,\"message\"],[24,0,\"flag-message\"],[16,\"placeholder\",[30,0,[\"customPlaceholder\"]]],[16,\"aria-label\",[28,[37,5],[\"flagging.notify_user_textarea_label\"],null]]],[[\"@value\"],[[30,0,[\"message\"]]]],null],[1,\"            \"],[10,0],[15,0,[28,[37,6],[\"custom-message-length\",[30,0,[\"customMessageLengthClasses\"]]],null]],[12],[1,\"\\n              \"],[1,[30,0,[\"customMessageLength\"]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,0,[\"staffFlagsAvailable\"]],[[[1,\"      \"],[10,\"hr\"],[12],[13],[1,\"\\n      \"],[10,\"h3\"],[12],[1,[28,[35,5],[\"flagging.notify_staff\"],null]],[13],[1,\"\\n\"]],[]],null]],[]],[[[1,\"    \"],[10,0],[15,0,[29,[\"controls \",[30,0,[\"flag\",\"name_key\"]]]]],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"radio checkbox-label\"],[12],[1,\"\\n        \"],[11,\"input\"],[16,1,[29,[\"radio_\",[30,0,[\"flag\",\"name_key\"]]]]],[24,3,\"post_action_type_index\"],[24,4,\"radio\"],[4,[38,1],[\"click\",[28,[37,2],[[30,0],\"changePostActionType\",[30,0,[\"flag\"]]],null]],null],[12],[13],[1,\"\\n        \"],[10,0],[14,0,\"flag-action-type-details\"],[12],[1,\"\\n          \"],[10,\"strong\"],[12],[1,[30,0,[\"formattedName\"]]],[13],[1,\"\\n\"],[41,[30,0,[\"showDescription\"]],[[[1,\"            \"],[10,0],[14,0,\"description\"],[12],[1,[28,[35,3],[[30,0,[\"description\"]]],null]],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"showMessageInput\"]],[[[1,\"            \"],[8,[39,4],[[24,3,\"message\"],[24,0,\"flag-message\"],[16,\"placeholder\",[30,0,[\"customPlaceholder\"]]],[16,\"aria-label\",[28,[37,5],[\"flagging.notify_moderators_textarea_label\"],null]]],[[\"@value\"],[[30,0,[\"message\"]]]],null],[1,\"            \"],[10,0],[15,0,[28,[37,6],[\"custom-message-length\",[30,0,[\"customMessageLengthClasses\"]]],null]],[12],[1,\"\\n              \"],[1,[30,0,[\"customMessageLength\"]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,0,[\"showConfirmation\"]],[[[1,\"        \"],[10,\"label\"],[14,0,\"checkbox-label flag-confirmation\"],[12],[1,\"\\n          \"],[8,[39,7],[[24,3,\"confirmation\"]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"isConfirmed\"]]]],null],[1,\"\\n          \"],[10,1],[12],[1,[28,[35,5],[\"flagging.confirmation_illegal\"],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]]],[13]],[],false,[\"if\",\"on\",\"action\",\"html-safe\",\"textarea\",\"i18n\",\"concat-class\",\"input\"]]",
  "moduleName": "discourse/components/flag-action-type.hbs",
  "isStrictMode": false
});